import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firebaseConnect } from 'react-redux-firebase'
import { fabric } from 'fabric'
import PropTypes from 'prop-types'
import * as _ from 'lodash'

import Palette from '../components/Palette'
import Button from '../components/Button'


import {
        CANVAS_SIZE, 
        CONTINUOUS_USERFLOW,
        CANVAS_SIZE_PORTRAIT_LAYOUT,
        CANVAS_SIZE_MAX_TABLET,
        MOBILE_WIDTH,
        MOBILE_WIDTH_LARGE,
        CONTAINER_MAX_WIDTH,
        TABLET_WIDTH_LARGE,
        DRAWING_CONTAINER_PADDING
        } 
        from '../constants'

class CanvasContainer extends React.Component {
  static contextTypes = {
    router: PropTypes.shape({
      history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired,
        createHref: PropTypes.func.isRequired,
      }).isRequired,
    }).isRequired,
  }

  constructor(props) {
    super(props)
    this.canvasObjectIds = []
  }

  state = {
    selectedColor: null,
    brushWidth: 10,
    colors: [
      '#FF6633',
      '#FFB399',
      '#FF33FF',
      '#FFFF99',
      '#00B3E6',
      '#E6B333',
      '#3366E6',
      '#999966',
      '#99FF99',
      '#B34D4D',
    ],
    colorsInitialized: false,
    isHintVisible: false,
    canvasSize: CANVAS_SIZE,
  }

  componentDidMount() {
    this.initializeCanvas()
    this.initializeColors()
    this.isSaved = false
    window.addEventListener('beforeunload', this.onWindowCloseHandler)
    window.addEventListener('resize', this.reSize )
    this.reSize();
  }

  componentDidUpdate() {
    // TODO: Figure out why this is needed (pallette seems to crash)
    if (this.props.drawing && !this.state.colorsInitialized) {
      this.initializeColors()
    }
  }

  onBrushStroke() {
    /**
     * First we extract ONLY the properties of canvas objects that aren't constant.
     * The rest will be rehydrated upon reception from the firebase.
     *  */
    const canvasObjects = this.canvas
      .toJSON()
      .objects.map(({ height, left, stroke, strokeWidth, top, width, path }) => ({
        height,
        left,
        stroke,
        strokeWidth,
        top,
        width,
        path,
      }))

    const latestCanvasObject = canvasObjects[canvasObjects.length - 1]
    const canvasObjectId = this.props.firebase
      .ref(`canvasSnapshots/${this.props.canvasSnapshotId}/canvasSnapshot/objects`)
      .push(latestCanvasObject).key
    // store this key in a local class array for use in the UNDO method
    this.canvasObjectIds.push(canvasObjectId)
  };



  calcCanvasSize = ()=> {
    
    let screenWidth = window.innerWidth;
    let screenHeight = window.innerHeight;
    let aspectRatio = screenHeight/screenWidth;
    let canvasSize;
    if (screenWidth > MOBILE_WIDTH_LARGE && screenWidth < CONTAINER_MAX_WIDTH){
      canvasSize = screenWidth *0.85 - DRAWING_CONTAINER_PADDING*2 ;
    }
    else if ((screenWidth >= CONTAINER_MAX_WIDTH && screenWidth < TABLET_WIDTH_LARGE)||
    (screenWidth >= TABLET_WIDTH_LARGE &&  (aspectRatio < 1.6 && aspectRatio >= 1.3) )){
      canvasSize = CANVAS_SIZE_MAX_TABLET;
    }
    else if (screenWidth >= TABLET_WIDTH_LARGE){
      canvasSize = CANVAS_SIZE_PORTRAIT_LAYOUT
    } 
    else if (screenWidth < MOBILE_WIDTH){
      canvasSize = screenWidth *0.9;
    }
    else{
      canvasSize = CANVAS_SIZE;
    }
    return canvasSize;
  }

  initializeCanvas() {
    
    // set the initial canvas size

    let canvasSize = this.calcCanvasSize ();

    this.setState({ canvasSize });
    
    // Initialize the canvas element
    const canvas = new fabric.Canvas('c', {
      width: canvasSize,
      height: canvasSize,
      isDrawingMode: true,
    })


    // Set some defaults on the canvas
    canvas.freeDrawingBrush.width = 10
    fabric.Object.prototype.transparentCorners = false

    // setup callback to be triggered on every path creation event
    canvas.on('path:created', () => {
      this.onBrushStroke()
    })

    // Make this canvas accessible to rest of class
    this.canvas = canvas

    // Create the root canvasSnapshot for this user drawing.
    this.props.firebase.ref(`canvasSnapshots/${this.props.canvasSnapshotId}`).update({
      userDrawingSquare: `${this.props.userId}_${this.props.drawingId}`,
      canvasObjects: [],
      user: this.props.userId,
      drawing: this.props.drawingId,
      userDrawing: `${this.props.userId}_${this.props.drawingId}`,
    })

  }

  onWindowCloseHandler = () => {
    if (!this.isSaved) {
      this.deleteSquare(this.props.canvasSnapshotId)
    }
    this.canvas.dispose();
    window.removeEventListener('beforeunload', this.onWindowCloseHandler)
  }

  initializeColors() {
    if (!this.state.getColorsInitialized && this.props.drawing) {
      this.setState({ colorsInitialized: true })
      this.getDrawingSquareColors()
    }
  }

  getCoords() {
    const squareNumber = this.props.match.params.drawingSquareId.substr(
      this.props.match.params.drawingSquareId.lastIndexOf('_') + 1,
    )
    const { squaresCount } = this.props.drawing
    const squaresAcross = Math.sqrt(squaresCount)
    let x
    let y
    for (let row = 1; row < squaresAcross + 1; row++) {
      if (squareNumber <= row * squaresAcross) {
        y = row - 1
        break
      }
    }

    x = (squareNumber % squaresAcross === 0 ? squaresAcross : squareNumber % squaresAcross) - 1
    return [x, y]
  }

  colorSelected = (color) => {
    this.setState({ selectedColor: color })
    this.canvas.freeDrawingBrush.color = color
  }

  isLoaded() {
    return this.props.drawing && this.state.colors && this.state.selectedColor
  }

  getDrawingSquareColors() {
    const colors = this.props.drawing.images[this.props.drawingIndex].colors
    if (colors) {
      this.setState({ colors })
      this.colorSelected(colors[0])
    }
  }

  defineHeaderContent = (drawing) => {
    let content = 'Color your square'
    if (drawing && drawing.instruction) {
      content = drawing.instruction
    }
    return content
  }

  defineAdditionalInstructionContent = (drawing) => {
    let content = ''
    if (this.isLoaded() && drawing && drawing.additionalInstruction) {
      content = drawing.additionalInstruction
    }
    return content
  }

  setBrushWidth = (event) => {
    const width = parseInt(event.target.value, 10)
    this.canvas.freeDrawingBrush.width = width
    this.setState({ brushWidth: width })
  }

  reSize = () => {

    // resize the canvas as the window size changes
    let prevCanvasSize = this.state.canvasSize
    let canvasSize = this.calcCanvasSize()

    // calculate the difference between previous and new window size
    let delta =  canvasSize/ prevCanvasSize

    this.setState({ canvasSize });
    this.canvas.setHeight( canvasSize );
    this.canvas.setWidth( canvasSize );

    // set the zoom of the objects (brush strokes) to the same difference as the window size change

    this.canvas.setZoom(this.canvas.getZoom() * delta ) 

  };


  showHint = () => {
    this.setState({
      isHintVisible: !this.state.isHintVisible,
    })
  }

  deleteSquare = async (canvasSnapshotKey) => {
    const {
      drawingId,
      match: {
        params: { drawingSquareId },
      },
    } = this.props

    // squares are stored as index of an array in firebase.
    const squareIndex = drawingSquareId.substr(drawingSquareId.lastIndexOf('_') + 1) - 1
    const drawRef = this.props.firebase.database().ref(`drawingSquares/${canvasSnapshotKey}`)
    const canvasRef = this.props.firebase.database().ref(`canvasSnapshots/${canvasSnapshotKey}`)

    // ref that contains lottery number in drawing object. needed to reset if user quits
    const drawingCurrentSquareRef = this.props.firebase.database().ref(`drawings/${drawingId}/squares/`)

    // todo update data structure and props to have cleaner way of associating drawings to squares and piccles
    await drawingCurrentSquareRef.update({ [squareIndex]: false })
    try {
      await Promise.all([drawRef.remove(), canvasRef.remove()])
    } catch (err) {
      console.log(err)
    }
  }

  canvasIsColored() {
    const canvasJSON = this.canvas.toJSON()
    return canvasJSON && canvasJSON.objects && canvasJSON.objects.length > 0
  }

  finishDrawing = async () => {
    const { drawingId, drawingIndex, canvasSnapshot, drawing, firebase, canvasSnapshotId } = this.props

    const signupUrl = `/drawings/${drawingId}/${drawingIndex}/signup/${canvasSnapshot.drawingSquare}`
    const doneUrl = `/drawings/${drawingId}/${drawingIndex}/done`
    const backToDrawingUrl = `/drawings/${drawingId}`

    if (!this.canvasIsColored()) {
      alert("You haven't drawn anything!")
      return
    }

    // add a complete status and finishTimestamp to the canvasSnapeshot
    await firebase.ref(`canvasSnapshots/${canvasSnapshotId}`).update({
      status: 'complete',
      finishTimestamp: new Date().valueOf(),
    })

    this.isSaved = true

    await firebase.ref(`drawingProgress/${drawingId}/${drawingIndex}`).transaction((currentVal) => {
      return (currentVal || 0) + 1
    })

    // If continuous mode, we go directly back to drawing page to pick a new square.
    if (drawing.userFlowType === CONTINUOUS_USERFLOW) {
      this.context.router.history.push(backToDrawingUrl)
    }
    // Else we pursue normal flow.
    else if (window.userSignedIn()) {
      this.context.router.history.push(doneUrl)
    } else {
      this.context.router.history.push(signupUrl)
    }
  }

  undoDrawing = () => {
    const canvasObjectsCount = this.canvasObjectIds.length
    if (canvasObjectsCount > 0) {
      this.canvas.remove(this.canvas.item(canvasObjectsCount - 1))
      this.canvas.renderAll()
      this.props.firebase
        .ref(`canvasSnapshots/${this.props.canvasSnapshotId}/canvasSnapshot/objects`)
        .child(this.canvasObjectIds.pop()) // here we pop the ID out of our local array as we pass it to firebase for removal
        .remove()
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const onlyUpdateOn = [
      // Only update if any of the following props have changed
      'auth',
      'drawingId',
      'userId',
      'drawing',
      'canvasSnapshotId',
      'canvasSnapshot',
      'userDrawingSquare',
      'colors',
      'selectedColor',
      'brushWidth',
      'canvasSize',
    ].some((key) => nextProps[key] !== this.props[key] || nextState[key] !== this.state[key])
    return onlyUpdateOn
  }

  render() {
    const { drawing, drawingIndex } = this.props
    const { brushWidth, isHintVisible, canvasSize } = this.state
    const headerContent = this.defineHeaderContent(drawing)
    const additionalInstruction = this.defineAdditionalInstructionContent(drawing)

    let styles = {}
    if (drawing) {
      let [x, y] = this.getCoords()
      styles = {
        backgroundImage: `url('${drawing.images[drawingIndex].imageUrl}')`,
        backgroundSize: `${canvasSize * Math.sqrt(drawing.squaresCount)}px`,
        borderColor: 'black',
        backgroundPositionX: `-${x * canvasSize}px`,
        backgroundPositionY: `-${y * canvasSize}px`,
        width: canvasSize,
        height: canvasSize,
        margin: 'auto',
        opacity: 0.8,
      }
    }

    return (
      <div className="container container--full">
        <h2 className="info-title hide-mobile">{headerContent}</h2>
             
        <div className={this.isLoaded() ? 'drawing-container-fluid' : 'display-none'}>
          <div
            style={{
              width: canvasSize,
              height: canvasSize,
              margin: 'auto',
            }}
          >
            <div style={styles} />
            <div style={{ marginTop: `-${canvasSize}px`}}>
              <canvas id="c" />
            </div>
          </div>
          <div className="instruments-container">
            <div className="palette-container">
              <Palette
                colors={this.state.colors}
                selectedColor={this.state.selectedColor}
                onSelect={this.colorSelected}
              />
            </div>
            <div className="range-container">
              <h5>Brush size:</h5>
              <input type="range" step={5} min={5} max={70} value={brushWidth} onChange={this.setBrushWidth} />
            </div>
            <div className="buttons-container">
              <Button type="reset" title="Undo" className="button-undo" onClickHandler={this.undoDrawing} />
              <Button type="submit" title={"I'm Done"} className="button-submit" onClickHandler={this.finishDrawing} />
            </div>
            <div className="info-box">
              <h2>{headerContent}</h2>
            </div> 
            {additionalInstruction ? (
              <div className="hint" onClick={this.showHint}>
                How it works?
              </div>
            ) : null}
          </div>
        </div>
        {!this.isLoaded() && <div>Loading...</div>}
        {isHintVisible ? <div className="hint">{additionalInstruction}</div> : null}
        <div className="green-bg"></div>
      </div>
    )
  }

  componentWillUnmount() {
    this.onWindowCloseHandler();
    window.removeEventListener('resize', this.reSize );
  }
}

export default compose(
  firebaseConnect((props) => {
    // Set listeners based on props (prop is route parameter from react-router in this case)
    return [
      `drawingSquares/${props.match.params.drawingSquareId}`,
      `drawings/${props.match.params.id}`,
      `canvasSnapshots/${props.match.params.drawingSquareId}`,
    ]
  }),
  connect((state, props) => {
    return {
      auth: state.firebase.auth,
      drawingId: props.match.params.id,
      drawingIndex: props.match.params.index,
      userId: state.firebase.auth.uid,
      drawing: _.get(state.firebase.data, `drawings.${props.match.params.id}`),
      canvasSnapshotId: `${props.match.params.drawingSquareId}`,
      canvasSnapshot: _.get(state.firebase.data, `canvasSnapshots.${props.match.params.drawingSquareId}`),
      userDrawingSquare: _.get(state.firebase.data, `drawingSquares.${props.match.params.drawingSquareId}`),
    }
  }),
)(CanvasContainer)



// WEBPACK FOOTER //
// ./src/containers/canvasContainer.js